import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { USGenericComponent } from './us-generic.component';

const routes: Routes = [{ path: '', component: USGenericComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class USGenericRoutingModule { }
